export const propertyListingHelperForResponsive = () => {
    let width = window.innerWidth;
    const deviceMapper = {
        320: { size: 320, display: 1 },
        480: { size: 480, display: 1 },
        540: { size: 540, display: 1.5 },
        768: { size: 768, display: 2 },
        900: { size: 900, display: 2.5 },
        1024: { size: 1024, display: 3 },
        1200: { size: 1200, display: 3 },
        1366: { size: 1366, display: 3.5 },
    }
    if (width <= 320) return deviceMapper[320]
    if (width > 321 && width <= 480) return deviceMapper[480]
    if (width > 481 && width <= 540) return deviceMapper[540]
    if (width > 540 && width <= 768) return deviceMapper[768]
    if (width > 769 && width <= 900) return deviceMapper[900]
    if (width > 901 && width <= 1024) return deviceMapper[1024]
    if (width > 1025 && width <= 1366) return deviceMapper[1366]
    if (width > 1367) return { display: 3.5 }
}



